/**
 * Date fields statements can be range-filtered on, shared by the filters drawer and the active
 * filter badge row so their labels never drift apart.
 * @readonly
 */
export const STATEMENTS_DATE_FIELDS = [
  { value: 'start_date', label: 'Start date' },
  { value: 'created_at', label: 'Created date' },
];

// Default `date` filter value for statements - kept in sync with STATEMENTS_DATE_FIELDS[0] so the
// store, the filters drawer, and the active filter badge all reset to the same field.
export const STATEMENTS_DEFAULT_DATE_FIELD = STATEMENTS_DATE_FIELDS[0].value;

const TRANSFERS_DATE_FIELDS_AGENCY = [
  { value: 'released_at', label: 'Released date' },
  { value: 'settled_at', label: 'Received date' },
];

const TRANSFERS_DATE_FIELDS_SUPPLIER = [
  { value: 'released_at', label: 'Sent date' },
  { value: 'settled_at', label: 'Received date' },
  { value: 'created_at', label: 'Created date' },
];

// Default `date` filter value for transfers - the same for both agency and supplier field sets,
// kept in sync with their shared first entry so the store, drawer, and badge never drift apart.
export const TRANSFERS_DEFAULT_DATE_FIELD = TRANSFERS_DATE_FIELDS_AGENCY[0].value;

/**
 * Date fields transfers can be range-filtered on. Agency and supplier use different labels for
 * the same fields, and agency has no "Created date" - see TransfersFiltersDrawer.vue's status
 * pill grouping for the same isAgency-conditioned pattern.
 * @param {boolean} isAgency
 * @returns {Array<{value: string, label: string}>}
 */
export const getTransfersDateFields = (isAgency) => {
  return isAgency ? TRANSFERS_DATE_FIELDS_AGENCY : TRANSFERS_DATE_FIELDS_SUPPLIER;
};
